module.exports = __webpack_public_path__ + "static/media/ic_circle_sucess_check.d9fb3918.svg";